<template>
  <div class="content-item" style="text-align: center">
    <h2 class="heading">Download the Church Introduction Video and Best Practices</h2>
    <p class="text">
      Now we are really getting close! Let’s go ahead and get the Best Practices downloaded. Please use this as your standard process for how to run TrueLife.org with your Church evangelism. Also
      download our introduction videos to help your church know how to hand out the cards. Feel free also to create your own.
    </p>
    <a-button style="background: #1c84c6; border: none" type="primary" @click="openLink">
      <span><a-icon type="download" />&nbsp;Download Video </span>
    </a-button>
    <a-button style="background: #1c84c6; border: none; margin-left: 20px" type="primary" @click="openPDFLink">
      <span><a-icon type="download" />&nbsp;Download Best Practices </span>
    </a-button>
  </div>
</template>

<script>
import { get } from 'lodash';
export default {
  name: 'Step6',
  props: {
    value: {
      type: Object,
    },
    source: {
      type: Object,
    },
  },
  computed: {
    backCards() {
      return get(this.source, 'back', []);
    },
  },
  data() {
    return {
      selected: {},
    };
  },
  methods: {
    openLink() {
      window.open('https://www.dropbox.com/scl/fi/p2mh7s3ewtixx6cvlq3c1/church_training_video_tl-1080p-1.mp4?rlkey=om5wv16a8miyf12uz111t1n13&st=e0x9x7d6&dl=1', '_blank');
    },
    openPDFLink() {
      window.open('https://www.dropbox.com/scl/fi/fxrsusaxxro22xf03sy60/TrueLife.org-Best-Practices.pdf?rlkey=gtqvz61lhsgc5ubka7z0va8n2&st=29bmoyq8&dl=1', '_blank');
    },
  },
};
</script>
